import { makeStyles } from 'tss-react/mui'


export const useStyles = makeStyles()((theme) => {
    return {
        container: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            borderRadius: 0,
            padding: '8px',
            alignItems: 'center'
        },
        item: {
            '&:not(first-child)': {
                marginLeft: theme.spacing(1)
            }
        }
    }
})